<div class="modal-box merge-campaign-modal" cdkDrag>
    <form class="merge-campaign-modal__form modal-form" [formGroup]="addCampaignForm" (ngSubmit)="onSubmit()">
        <div class="modal-header merge-campaign-modal__header" cdkDragHandle>
            <div class="merge-campaign-modal__headline modal-headline">
                <span class="merge-campaign-modal__eyebrow modal-eyebrow">{{ 'CAMPAIGN' | translate }}</span>
                <h4 class="modal-title merge-campaign-modal__title modal-heading">{{ 'MERGE_CAMPAIGNS' | translate }}</h4>
                <p class="merge-campaign-modal__subtitle" *ngIf="step==1">{{ 'MERGE_CAMPAIGNS_STEP_1' | translate }}</p>
                <p class="merge-campaign-modal__subtitle" *ngIf="step==2">{{ 'MERGE_CAMPAIGNS_STEP_2' | translate }}</p>
            </div>
            <button type="button" class="merge-campaign-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body merge-campaign-modal__body" *ngIf="step==1">
            <div class="merge-campaign-modal__sections merge-campaign-modal__sections--single modal-sections">
                <section class="merge-campaign-modal__panel modal-panel">
                    <div class="merge-campaign-modal__panel-header modal-panel-header">
                        <span class="merge-campaign-modal__panel-eyebrow modal-panel-eyebrow">{{ 'COMPARE' | translate }}</span>
                        <h5 class="merge-campaign-modal__panel-title modal-panel-title">{{ 'CHOOSE_PRIMARY_RECORD_AND_FIELD_VALUES' | translate }}</h5>
                    </div>

                    <div class="merge-campaign-modal__comparison-shell">
                        <table class="table merge-campaign-modal__table">
                            <thead>
                                <tr>
                                    <th class="merge-campaign-modal__label-column"><label>{{ 'PRIMARY_RECORD' | translate }}</label></th>
                                    <th *ngFor="let campaign of campaigns">
                                        <div class="merge-campaign-modal__column-header">
                                            <label class="merge-campaign-modal__radio-label">
                                                <input type="radio" [value]="campaign.id" formControlName="id" (click)="setPrimaryRecord(campaign.id)">
                                                <span>{{ campaign.name }}</span>
                                            </label>
                                            <button type="button" (click)="setPrimaryRecord(campaign.id)" class="merge-campaign-modal__select-all">
                                                {{ 'SELECT_ALL' | translate }}
                                            </button>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'CAMPAIGN_NAME' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.name" formControlName="name">
                                            <span>{{ campaign.name }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'STREET_ADDRESS' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.street" formControlName="street">
                                            <span>{{ campaign.street }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'CITY' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.city" formControlName="city">
                                            <span>{{ campaign.city }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'STATE' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.state" formControlName="state">
                                            <span>{{ campaign.state }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'ZIPCODE' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.zipcode" formControlName="zipcode">
                                            <span>{{ campaign.zipcode }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'PHONE' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.locationPhone" formControlName="locationPhone">
                                            <span>{{ campaign.locationPhone }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'EMAIL' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.locationEmail" formControlName="locationEmail">
                                            <span>{{ campaign.locationEmail }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'PLATFORM' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.platform" formControlName="platform">
                                            <span>{{ campaign.platform | P_CampaignPlatformTitle }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'STAGE' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.stageId" formControlName="stageId">
                                            <span>{{ getStageTitle(campaign.stageId) }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'CRM_ID' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.crmId" formControlName="crmId">
                                            <span>{{ campaign.crmId }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'CRM_NAME' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.crmName" formControlName="crmName">
                                            <span>{{ campaign.crmName }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'CLIENT' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.clientId" formControlName="clientId">
                                            <span>{{ campaign.clientName }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'DMS' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.dmsId" formControlName="dmsId">
                                            <span>{{ campaign.dmsName }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-campaign-modal__label-column"><label>{{ 'ADDITIONAL_INFO' | translate }}</label></td>
                                    <td *ngFor="let campaign of campaigns">
                                        <label class="merge-campaign-modal__radio-label">
                                            <input type="radio" [value]="campaign.opportunityNotes" formControlName="opportunityNotes">
                                            <span>{{ campaign.opportunityNotes }}</span>
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-body merge-campaign-modal__body" *ngIf="step==2">
            <div class="merge-campaign-modal__sections merge-campaign-modal__sections--single modal-sections">
                <section class="merge-campaign-modal__panel modal-panel">
                    <div class="merge-campaign-modal__panel-header modal-panel-header">
                        <span class="merge-campaign-modal__panel-eyebrow modal-panel-eyebrow">{{ 'DETAILS' | translate }}</span>
                        <h5 class="merge-campaign-modal__panel-title modal-panel-title">{{ 'MERGED_CAMPAIGN_CORE_DETAILS' | translate }}</h5>
                    </div>

                    <div class="merge-campaign-modal__grid merge-campaign-modal__grid--single modal-grid">
                        <div class="merge-campaign-modal__field merge-campaign-modal__field--span-2">
                            <label class="merge-campaign-modal__label" for="name">{{ 'CAMPAIGN_NAME' | translate }}</label>
                            <input id="name" type="text" class="form-control merge-campaign-modal__control" formControlName="name"
                                [ngClass]="{ 'is-invalid': submitted && f.name.errors }" [placeholder]="'ENTER_CAMPAIGN_NAME' | translate">
                            <div *ngIf="submitted && f.name.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.name.errors.required">{{ 'NAME_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field merge-campaign-modal__field--span-2">
                            <label class="merge-campaign-modal__label" for="street">{{ 'STREET_ADDRESS' | translate }}</label>
                            <textarea id="street" rows="3" class="form-control merge-campaign-modal__control merge-campaign-modal__control--textarea" formControlName="street"
                                [ngClass]="{ 'is-invalid': submitted && f.street.errors }" [placeholder]="'ENTER_LOCATION_STREET' | translate"></textarea>
                            <div *ngIf="submitted && f.street.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.street.errors.max">{{ 'STREET_MAX' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field">
                            <label class="merge-campaign-modal__label" for="city">{{ 'CITY' | translate }}</label>
                            <textarea id="city" rows="3" class="form-control merge-campaign-modal__control merge-campaign-modal__control--textarea" formControlName="city"
                                [ngClass]="{ 'is-invalid': submitted && f.city.errors }" [placeholder]="'ENTER_LOCATION_CITY' | translate"></textarea>
                            <div *ngIf="submitted && f.city.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.city.errors.max">{{ 'CITY_MAX' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field">
                            <label class="merge-campaign-modal__label" for="state">{{ 'STATE' | translate }}</label>
                            <textarea id="state" rows="3" class="form-control merge-campaign-modal__control merge-campaign-modal__control--textarea" formControlName="state"
                                [ngClass]="{ 'is-invalid': submitted && f.state.errors }" [placeholder]="'ENTER_LOCATION_STATE' | translate"></textarea>
                            <div *ngIf="submitted && f.state.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.state.errors.max">{{ 'STATE_MAX' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field">
                            <label class="merge-campaign-modal__label" for="zipcode">{{ 'ZIPCODE' | translate }}</label>
                            <textarea id="zipcode" rows="3" class="form-control merge-campaign-modal__control merge-campaign-modal__control--textarea" formControlName="zipcode"
                                [ngClass]="{ 'is-invalid': submitted && f.zipcode.errors }" [placeholder]="'ENTER_LOCATION_ZIPCODE' | translate"></textarea>
                            <div *ngIf="submitted && f.zipcode.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.zipcode.errors.max">{{ 'ZIPCODE_MAX' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field">
                            <label class="merge-campaign-modal__label" for="locationPhone">{{ 'PHONE' | translate }}</label>
                            <input id="locationPhone" type="text" class="form-control merge-campaign-modal__control" formControlName="locationPhone"
                                [ngClass]="{ 'is-invalid': submitted && f.locationPhone.errors }" [placeholder]="'ENTER_PHONE_NUMBER' | translate">
                            <div *ngIf="submitted && f.locationPhone.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.locationPhone.errors.required">{{ 'PHONE_REQUIRED' | translate }}</div>
                                <div *ngIf="f.locationPhone.errors.max">{{ 'PHONE_MAX' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field">
                            <label class="merge-campaign-modal__label" for="locationEmail">{{ 'EMAIL' | translate }}</label>
                            <input id="locationEmail" type="text" class="form-control merge-campaign-modal__control" formControlName="locationEmail"
                                [ngClass]="{ 'is-invalid': submitted && f.locationEmail.errors }" [placeholder]="'ENTER_EMAIL_ADDRESS' | translate">
                            <div *ngIf="submitted && f.locationEmail.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.locationEmail.errors.required">{{ 'EMAIL_REQUIRED' | translate }}</div>
                                <div *ngIf="f.locationEmail.errors.max">{{ 'EMAIL_MAX' | translate }}</div>
                                <div *ngIf="f.locationEmail.errors.email">{{ 'EMAIL_INVALID' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="merge-campaign-modal__panel modal-panel">
                    <div class="merge-campaign-modal__panel-header modal-panel-header">
                        <span class="merge-campaign-modal__panel-eyebrow modal-panel-eyebrow">{{ 'ASSIGNMENT' | translate }}</span>
                        <h5 class="merge-campaign-modal__panel-title modal-panel-title">{{ 'PLATFORM_CRM_AND_OWNERSHIP' | translate }}</h5>
                    </div>

                    <div class="merge-campaign-modal__grid merge-campaign-modal__grid--single modal-grid">
                        <div class="merge-campaign-modal__field">
                            <label class="merge-campaign-modal__label" for="platform">{{ 'PLATFORM' | translate }}</label>
                            <ng-select id="platform" class="merge-campaign-modal__select" [ngClass]="{ 'is-invalid': submitted && f.platform.errors }" formControlName="platform">
                                <ng-option *ngFor="let p of allPlatforms" [value]="p">{{ p | P_CampaignPlatformTitle }}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.platform.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.platform.errors.required">{{ 'PLATFORM_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field">
                            <label class="merge-campaign-modal__label" for="stageId">{{ 'STAGE' | translate }}</label>
                            <ng-select id="stageId" class="merge-campaign-modal__select" [ngClass]="{ 'is-invalid': submitted && f.stageId.errors }" formControlName="stageId">
                                <ng-option *ngFor="let stage of CAMPAIGN_STAGES" [value]="stage.value">{{ stage.translate | translate }}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.stageId.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.stageId.errors.required">{{ 'STAGE_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field">
                            <label class="merge-campaign-modal__label" for="crmId">{{ 'CRM_ID' | translate }}</label>
                            <input id="crmId" type="text" class="form-control merge-campaign-modal__control" formControlName="crmId"
                                [ngClass]="{ 'is-invalid': submitted && f.crmId.errors }" [placeholder]="'ENTER_CRM_ID' | translate">
                            <div *ngIf="submitted && f.crmId.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.crmId.errors.required">{{ 'CRM_ID_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field">
                            <label class="merge-campaign-modal__label" for="crmName">{{ 'CRM_NAME' | translate }}</label>
                            <div class="merge-campaign-modal__crm-row">
                                <ng-select *ngIf="!isCustomCrmName" id="crmName" class="merge-campaign-modal__select" formControlName="crmName">
                                    <ng-option *ngFor="let c of defaultCRMNames" [value]="c.value">{{ c.title }}</ng-option>
                                </ng-select>
                                <input *ngIf="isCustomCrmName" id="crmName" type="text" class="form-control merge-campaign-modal__control" formControlName="crmName"
                                    [ngClass]="{ 'is-invalid': submitted && f.crmName.errors }" [placeholder]="'ENTER_CRM_NAME' | translate">
                                <button *ngIf="isCustomCrmName" type="button" class="merge-campaign-modal__icon-button" (click)="onShowDropdown()" [attr.title]="'SHOW_DROPDOWN' | translate">
                                    <i-feather name="corner-right-up" class="icon-sm"></i-feather>
                                </button>
                            </div>
                            <div *ngIf="submitted && f.crmName.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.crmName.errors.required">{{ 'CRM_NAME_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field">
                            <label class="merge-campaign-modal__label" for="clientId">{{ 'CLIENT' | translate }}</label>
                            <ng-select id="clientId" class="merge-campaign-modal__select" [ngClass]="{ 'is-invalid': submitted && f.clientId.errors }" (change)="updateProspectClientDetails()" formControlName="clientId">
                                <ng-option *ngFor="let c of allClients" [value]="c.id">{{ c.firstName }} {{ c.lastName }}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.clientId.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.clientId.errors.required">{{ 'CLIENT_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field" [ngClass]="{'disabled' : options !== null && !options.canAssign}">
                            <label class="merge-campaign-modal__label" for="dmsId">{{ 'DMS' | translate }}</label>
                            <ng-select id="dmsId" class="merge-campaign-modal__select" [ngClass]="{ 'is-invalid': submitted && f.dmsId.errors }" formControlName="dmsId">
                                <ng-option *ngFor="let rep of allDms" [value]="rep.id">{{ rep.firstName }} {{ rep.lastName }}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.dmsId.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.dmsId.errors.required">{{ 'DMS_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-campaign-modal__field merge-campaign-modal__field--span-2">
                            <label class="merge-campaign-modal__label" for="opportunityNotes">{{ 'ADDITIONAL_INFO' | translate }}</label>
                            <textarea id="opportunityNotes" rows="4" class="form-control merge-campaign-modal__control merge-campaign-modal__control--textarea" formControlName="opportunityNotes"
                                [ngClass]="{ 'is-invalid': submitted && f.opportunityNotes.errors }" [placeholder]="'ENTER_ADDITIONAL_INFO' | translate"></textarea>
                            <div *ngIf="submitted && f.opportunityNotes.errors" class="merge-campaign-modal__feedback">
                                <div *ngIf="f.opportunityNotes.errors.required">{{ 'ADDITIONAL_INFO_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-footer merge-campaign-modal__footer" *ngIf="step==1" cdkDragHandle>
            <div class="merge-campaign-modal__actions modal-actions">
                <button type="button" class="red-outline-button merge-campaign-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
                <button [disabled]="!(addCampaignForm.value.id)" type="button" class="blue-button merge-campaign-modal__button modal-button" (click)="nextStep()" [attr.title]="'SELECT_PRIMARY_RECORD_TO_PROCEED' | translate">{{ 'NEXT' | translate }}</button>
            </div>
        </div>

        <div class="modal-footer merge-campaign-modal__footer" *ngIf="step==2" cdkDragHandle>
            <div class="merge-campaign-modal__actions modal-actions">
                <button type="button" class="red-outline-button merge-campaign-modal__button modal-button" (click)="activeModal.close('Cross click')">{{ 'CANCEL' | translate }}</button>
                <button type="button" class="blue-button merge-campaign-modal__button modal-button" (click)="previousStep()">{{ 'BACK' | translate }}</button>
                <button type="submit" class="orange-button merge-campaign-modal__button modal-button">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
